import { useClientContext } from "@hooks/index";
import { useMemo } from "react";
import { getMeta, updateMeta } from "./index";

export const useGoalsConfig = () => {
  const customFetch = useClientContext();

  return useMemo(
    () => ({
      getMeta: getMeta(customFetch),
      updateMeta: updateMeta(customFetch),
    }),
    [customFetch]
  );
};
